import { SxProps, Tooltip, Typography, TypographyProps } from '@mui/material';
import React from 'react';

interface LineClampProps extends TypographyProps {
    text: string;
    lineClamp?: number;
    sx?: SxProps;
    other?: object;
    showTooltipOnHover?: boolean;
}

export default ({ text, sx = undefined, lineClamp = 2, showTooltipOnHover = true, other }: LineClampProps) => {
    const typography = (
        <Typography
            sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: lineClamp,
                WebkitBoxOrient: 'vertical',
                ...sx
            }}
            {...other}
        >
            {text}
        </Typography>
    );

    return showTooltipOnHover ? <Tooltip title={text}>{typography}</Tooltip> : typography;
};
